import React, { Component } from "react"
import { Table } from "reactstrap"

import { Link } from "react-router-dom"


const responseExample = [{"point_balance":{"N":"5150"},"token_id":{"N":"8826"},"author":{"S":"geeky_shubhu"}},{"point_balance":{"N":"1925"},"token_id":{"N":"12123"},"author":{"S":"Shiraj786"}},{"point_balance":{"N":"1925"},"token_id":{"N":"13032"},"author":{"S":"KHUSHAL20"}},{"point_balance":{"N":"1325"},"token_id":{"N":"7840"},"author":{"S":"BishopOlaoluwa"}},{"point_balance":{"N":"1100"},"token_id":{"N":"563"},"author":{"S":"A56SN7"}},{"point_balance":{"N":"1025"},"token_id":{"N":"4286"},"author":{"S":"Udaygurjar99"}},{"point_balance":{"N":"725"},"token_id":{"N":"6307"},"author":{"S":"GhooLayung"}},{"point_balance":{"N":"575"},"token_id":{"N":"12293"},"author":{"S":"Woodmark520"}},{"point_balance":{"N":"500"},"token_id":{"N":"39984"},"author":{"S":"Halexfemii"}},{"point_balance":{"N":"425"},"token_id":{"N":"39935"},"author":{"S":"LukeD1"}},{"point_balance":{"N":"350"},"token_id":{"N":"3"},"author":{"S":"Dluks82"}},{"point_balance":{"N":"275"},"token_id":{"N":"8530"},"author":{"S":"HelderSepu"}},{"point_balance":{"N":"275"},"token_id":{"N":"1628"},"author":{"S":"levi9515"}},{"point_balance":{"N":"200"},"token_id":{"N":"39983"},"author":{"S":"GlowieAnastasia"}},{"point_balance":{"N":"200"},"token_id":{"N":"40050"},"author":{"S":"rk690"}},{"point_balance":{"N":"200"},"token_id":{"N":"39990"},"author":{"S":"westking11"}},{"point_balance":{"N":"200"},"token_id":{"N":"8"},"author":{"S":"TiagoFirmiano"}},{"point_balance":{"N":"200"},"token_id":{"N":"39854"},"author":{"S":"nikhunt1"}},{"point_balance":{"N":"200"},"token_id":{"N":"24193"},"author":{"S":"Mohamdbd9"}},{"point_balance":{"N":"200"},"token_id":{"N":"40000"},"author":{"S":"Dozzyzx"}},{"point_balance":{"N":"125"},"token_id":{"N":"35922"},"author":{"S":"josetteswanbaby"}},{"point_balance":{"N":"125"},"token_id":{"N":"33681"},"author":{"S":"Navinarora"}},{"point_balance":{"N":"125"},"token_id":{"N":"39962"},"author":{"S":"uknowifuknowi"}},{"point_balance":{"N":"125"},"token_id":{"N":"27511"},"author":{"S":"sahl333"}},{"point_balance":{"N":"125"},"token_id":{"N":"1589"},"author":{"S":"go9090"}},{"point_balance":{"N":"125"},"token_id":{"N":"5067"},"author":{"S":"Dayn007"}},{"point_balance":{"N":"125"},"token_id":{"N":"825"},"author":{"S":"ChessDude"}},{"point_balance":{"N":"125"},"token_id":{"N":"18612"},"author":{"S":"aslam583"}},{"point_balance":{"N":"125"},"token_id":{"N":"39976"},"author":{"S":"gregmarlin"}},{"point_balance":{"N":"125"},"token_id":{"N":"3123"},"author":{"S":"Matthizreal"}},{"point_balance":{"N":"125"},"token_id":{"N":"39982"},"author":{"S":"Amenawon5"}},{"point_balance":{"N":"125"},"token_id":{"N":"14582"},"author":{"S":"figurhoirifalah"}},{"point_balance":{"N":"125"},"token_id":{"N":"14277"},"author":{"S":"Liusag"}},{"point_balance":{"N":"125"},"token_id":{"N":"782"},"author":{"S":"Fucktrio"}},{"point_balance":{"N":"125"},"token_id":{"N":"3993"},"author":{"S":"sweefhty"}},{"point_balance":{"N":"125"},"token_id":{"N":"39991"},"author":{"S":"Dreamchaser_0"}},{"point_balance":{"N":"125"},"token_id":{"N":"12"},"author":{"S":"SixPathsPa1n"}},{"point_balance":{"N":"125"},"token_id":{"N":"15790"},"author":{"S":"cabharatgirdhar"}},{"point_balance":{"N":"125"},"token_id":{"N":"39969"},"author":{"S":"prashant1205"}},{"point_balance":{"N":"125"},"token_id":{"N":"39839"},"author":{"S":"Martiloo"}},{"point_balance":{"N":"125"},"token_id":{"N":"4432"},"author":{"S":"pawanregmi28"}},{"point_balance":{"N":"125"},"token_id":{"N":"30"},"author":{"S":"defiants_Tony"}},{"point_balance":{"N":"125"},"token_id":{"N":"39877"},"author":{"S":"Cryptozappi"}}]


class Leaderboard extends Component {
    
    state = {
        leaderBoard: []
    }

    

    getLeaderboard() {
        fetch('https://leaderboard.idexo.io')
                    .then(res => res.json())
                    .then(data => { 
                        this.setState({ leaderBoard: data.data })

                    })
                    
    }

    componentDidMount() {
        this.getLeaderboard()
        
    }

    render() {
        return (
            <React.Fragment>
                
                    <div style={{ overflow: "auto" }}>
                    <Table className="align-middle mb-0 table-nowrap">
                        <thead className="table-light">
                            <tr>
                                <th scope="col">Rank</th>
                                <th scope="col">Token ID</th>
                                <th scope="col">Username</th>
                                <th scope="col">Point Balance</th>
                                
                            </tr>
                        </thead>
                        <tbody>
                            
                            {this.state.leaderBoard.map((item, index) => {
                                return <tr>
                                <td>{index + 1}</td>
                                <td>{item.token_id.N}</td>
                                <td>{item.author.S}</td>
                                <td>{item.point_balance.N}</td>
                                </tr>
                            })}
                               
                                
                           
                        </tbody>
                    </Table>
           
                </div>
            </React.Fragment>
        )
    }
}

export default Leaderboard